import { render, staticRenderFns } from "./iCabbiPromotion.vue?vue&type=template&id=3562be60&scoped=true"
import script from "./iCabbiPromotion.vue?vue&type=script&lang=js"
export * from "./iCabbiPromotion.vue?vue&type=script&lang=js"
import style0 from "./iCabbiPromotion.vue?vue&type=style&index=0&id=3562be60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562be60",
  null
  
)

export default component.exports